<template>
    <div id="card-details" ref="painelRequest">
        <div id="infotitulo">
            <p class="title"><i class="pl-3 fas fa-clipboard-list"> </i> RESUMO</p>
        </div>
        <div class="card-details-body mt-4 ml-4">

            <div id="footer-card-details">
                <i class="fas fa-building titleEmpreendimento"></i>
                <p class="titleEmpreendimento">{{selectedSolicitacao.empreendimento.nome}}</p>
            </div>

            <p class="label-details">Status</p>
            <div id="circle" >
            <p class="result-status" :style="'background:' +  statusColor"> {{statusText}} </p> </div>
            <div v-if="selectedSolicitacao.status === 1 || selectedSolicitacao.status === 3">
            <p class="label-details ">Observação</p>
            <p class="result-details">{{selectedSolicitacao.pendencia === '' ? '-' : selectedSolicitacao.pendencia}}</p>
            </div>
            <p class="label-details">Cliente</p>
            <p class="result-details">{{selectedSolicitacao.cliente.nome}}</p>
            <p class="label-details">Data de Solicitação</p>
            <p class="result-details"> {{selectedSolicitacao.cliente.dataAcaoFormatada}}</p>
            <p class="label-details">Imobiliária</p>
            <p class="result-details">{{selectedSolicitacao.credenciada.nome}}</p>
            <p class="label-details">Corretor</p>
            <p class="result-details">{{selectedSolicitacao.conta.nome}}</p>
        </div>
    </div>
</template>

<script>
import PanelRequest from './panelRequest'
export default PanelRequest
</script>

<style scoped>
.label-details{
    font-size: 15px;
    color: black;
}
.teste{
   width: 350px;
   display: flex;
   justify-content: center;
}
#card-details{
  height: 100%;
  background: white;
  margin-bottom: 2%;
}

.title{
    font-size: 18px;
}

@media (min-width: 800px ) and (max-width: 1400px) {
  .titleEmpreendimento{
      color: #5a5a5a;
      font-size: 17px;
      font-weight: 700;
      line-height: 30px;
  }
}

@media (min-width: 1401px ){
  .titleEmpreendimento{
    color: #5a5a5a;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
  }
}

.titleRequest{
    font-size: 18px;
    margin-bottom: 15px;
    font-weight: bold;
    line-height: 25px;
}

.subtitle{
    font-size: 18px;
    color: #008148;
    font-weight: bold;
}

.input-details{
    width: 100%;
    height: 35px;
    background-color: #F1F1F1;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
}
.Pessoa{
    font-size:18px;
    text-align: center;
}
.result-details{
    font-size: 13px;
    text-align: justify;
    padding-right: 2rem;
    font-weight: bold;
    font-family: 'Segoe UI'
}
.result-status{
    display:table; /* keep the background color wrapped tight */
    padding:5px;
    padding-left: 20px;
    padding-right: 20px;
    font-size:15px;
    background-color: #F6B535;
    color:#ffffff;
    border-radius: 25px;
}
.head-right {
  height: 59px;
  display: flex;
  width: 100%;
  background: #ECEFF1 0% 0% no-repeat padding-box;
  border: 1px solid #CFD8DC;
  border-radius: 4px 4px 0px 0px;
  opacity: 1;
}
#details-board{
    height: 80vh;
    width: 100%;
    background-color:white;
}
.text-tabs{
    font-size: 16px;
    margin-left: 5px;
    font-weight: bold;
    margin-top: 10px;
}

#footer-card-details{
    display: flex;
    font-size: 16px;
    font-weight: bold;
    gap: 7px;
    padding:  1rem 1rem 0 0;
    color: #4F4C4D;
}
#card-img{
    height: 250px;
}
#infotitulo{
    height: 50px;
    width: 100%;
    font-size: 20px;
    background-color: #008148;
    padding-top: 15px;
    color: white;
}
hr{
    width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/requests/components/panelRequest/panelRequest.vue